export default "__VITE_ASSET__C70TC1Cn__"